import OneTrust, { ConsentService } from './one-trust';

/**
 * Get the consent key for a specific category
 * These keys are defined in the admin panel
 * under Advanced > Consents
 */
export function getConsentKey(category: string) {
  return `cookie_consent_${category}`;
}

/**
 * Get the user's consent for a specific category
 */
export function getConsentForCategory(
  category: 'performance' | 'functional' | 'targeting'
) {
  return OneTrust.getConsentForCategory(category);
}

/**
 * Get the user's preferences for all categories
 */
export function getUserPreferences() {
  return OneTrust.getUserPreferences();
}

/**
 * Store the user's preferences for all categories
 */
export function storeCookiePreferencesHelper(consentService: ConsentService) {
  if (!hasBannerInteraction()) {
    return;
  }

  return OneTrust.storeCookiePreferences(consentService);
}

/**
 * Determines if the user has made a selection
 */
export function hasBannerInteraction() {
  return OneTrust.hasBannerInteraction();
}
